import React from "react";
import MySurveysContainer from "../../containers/MySurveys/MySurveysContainer";

const MySurveysPage = () => {
  return (
    <>
      <MySurveysContainer />
    </>
  );
};

export default MySurveysPage;
